import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationModal from './NotificationModal';
import { resetNotification } from '../../store/actions/notificationAction';
import Notification from '../../models/Notification';

interface NotificationProps { 
  notification: Notification,
  resetNotification: Function
};

class NotificationContainer extends Component<NotificationProps> {
  state = {
  };

  handleClose = () => {
    this.props.resetNotification();
  };

  render() {
    return (
      <NotificationModal notification={ this.props.notification } handleClose={this.handleClose}></NotificationModal>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    notification: state.notification
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    resetNotification: () => dispatch(resetNotification())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationContainer);;